<template>
  <v-dialog
    v-model="show"
    :max-width="$vuetify.breakpoint.xs ? 'auto' : '500px'"
  >
    <v-card class="rounded-xl" color="#ffffffD9">
      <v-card-title class="">
        <span
          class="
              primary--text
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
        ></span>
      </v-card-title>
      <v-card-text class="my-0 py-0">
        <v-form ref="form" lazy-validation>
          <v-container fluid>
            <v-row>
              <v-col cols="12" class="my-0 py-0">
                <v-text-field
                  v-model="product.name"
                  outlined
                  clearable
                  dense
                  :label="translations.label_name"
                  counter="10"
                  maxlength="10"
                  class="
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
                  :rules="validation(translations.field_required)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-text-field
                  v-model="product.doses"
                  outlined
                  clearable
                  dense
                  :label="translations.label_dose"
                  type="number"
                  class="
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
                  :rules="validation(translations.field_required)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-combobox
                  v-model="product.type"
                  outlined
                  clearable
                  dense
                  :label="translations.label_type"
                  :items="types"
                  item-text="name"
                  class="
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
                  :rules="validation(translations.field_required)"
                ></v-combobox>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-text-field
                  v-model="product.activeIngredient"
                  outlined
                  clearable
                  dense
                  :label="translations.label_active_ingredient"
                  type="text"
                  class="
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
                  :rules="validation(translations.field_required)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="my-0 py-0">
                <v-text-field
                  v-model="product.target"
                  outlined
                  clearable
                  dense
                  :label="translations.label_objective"
                  type="text"
                  class="
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
                  :rules="validation(translations.field_required)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="newProduct"
          block
          class="
              mb-5
              text-subtitle-2
              text-sm-subtitle-1
              text-md-subtitle-1
              text-lg-subtitle-1
              text-xl-subtitle-1
            "
        >
          {{ translations.label_add_product }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
// Validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
  props: {
    value: Boolean,
  },
  data: () => ({
    product: {
      applicationDate: "",
      name: null,
      doses: null,
      type: null,
      uuid: uuidv4(),
      activeIngredient: null,
      target: null,
    },
    types: [
      {
        name: "Liquido",
        value: "LIQUID",
      },
      {
        name: "Solido",
        value: "SOLID",
      },
    ],
  }),
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    newProduct() {
      if (this.$refs.form.validate()) {
        this.product.doses = parseFloat(this.product.doses);
        this.product.type = this.product.type.value;
        this.$emit("newProduct", this.product);
      }
      //   if (this.data.name.length > 0) {
      //     this.$emit("getName", this.data.name);
      //     this.data = { error: false, message: "", name: "" };
      //     this.show = false;
      //   } else {
      //     this.data.error = true;
      //     this.data.message = "Campo requerido";
      //   }
    },
    validation(value) {
      return requiredValidation(value);
    },
  },
};
</script>

<style scoped></style>
